import type { PixelModule } from './types';

export class ModuleRegistry {
  private readonly modules: PixelModule[] = [];

  register(module: PixelModule): void {
    if (this.modules.some(existing => existing.name === module.name)) {
      throw new Error(`[Pixel] Module "${module.name}" is already registered`);
    }

    this.modules.push(module);
  }

  getAll(): readonly PixelModule[] {
    return this.modules;
  }

  size(): number {
    return this.modules.length;
  }
}
